import { useEffect, useMemo } from 'react';
import { PayoutRuleType, useForm } from '@common-fe/common-fe';

import { NA_KEY } from '../../hooks/useTierFields';
import { TierField } from '../../hooks/useTiers';
import { TierFormField, TierFormValues } from '../tierItem.types';

export const useTierForm = (defaultValues?: Partial<TierField>) => {
  const formDefaultValues = useMemo<TierFormValues>(
    () => ({
      [TierFormField.name]: defaultValues?.name || '',
      [TierFormField.payoutDefinition]: defaultValues?.payoutDefinitionName || '',
      [TierFormField.triggers]: defaultValues?.triggers?.length ? defaultValues.triggers : [NA_KEY],
      [TierFormField.aggregateTriggerName]: defaultValues?.aggregateTriggerName || undefined,
      [TierFormField.embeddedTriggerName]: defaultValues?.embeddedTriggerName || undefined,
      [TierFormField.payoutRuleType]:
        (defaultValues?.payoutRuleType as PayoutRuleType) || PayoutRuleType.NO_EXCEPTIONS,
      [TierFormField.isSendTriggerNotification]: defaultValues?.isSendTriggerNotification
        ? 'Send notifications'
        : undefined,
      [TierFormField.displayName]: defaultValues?.displayName || undefined,
      [TierFormField.planName]: defaultValues?.planName || undefined,
      [TierFormField.lockCardPurse]: defaultValues?.lockCardPurse || undefined,
      [TierFormField.planIdsForCardPurseLock]: defaultValues?.planIdsForCardPurseLock || [],
      [TierFormField.planNamesForCardPurseLock]: defaultValues?.planNamesForCardPurseLock || undefined,
    }),
    [defaultValues]
  );

  const methods = useForm<TierFormValues>({
    defaultValues: formDefaultValues,
  });

  useEffect(() => {
    methods.reset(formDefaultValues);
  }, [formDefaultValues, methods]);

  return { methods };
};
